// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titleIDE[data-v-690bb629]{border-radius:8px!important;padding:7px 12px}.titleIDE[data-v-690bb629],.titleIDE-card[data-v-690bb629]{font-size:15px;font-weight:700}.background-title[data-v-690bb629]{background:var(--v-cardTitle-base)}.button-filter[data-v-690bb629]{border-radius:0!important;height:2.5rem!important;margin:0!important;padding:0!important;position:absolute!important;right:5rem!important;top:7.6rem!important;z-index:1!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
